(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["finanzierung-landingpage"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const root = document.querySelector('.ft-page');
    if (!root) return;

    const RATE_BY_DURATION = { 6: 0.00, 12: 0.00, 24: 2.90, 36: 3.90 };
    const MIN_AMOUNT = 99;
    const MAX_AMOUNT = 12000;
    const MIN_RATE = 10;
    const PRODUCTS_PER_PAGE = 10;

    // Produkt-Daten aus dem inline JSON-Block laden
    let products = [];
    const dataEl = document.getElementById('ft-products-data');
    if (dataEl) {
      try { products = JSON.parse(dataEl.textContent.trim()) || []; }
      catch (e) { console.warn('[Finanzierung] Produkt-JSON konnte nicht geparst werden', e); }
    }

    function calcRate(principal, months, effRatePercent) {
      const i = effRatePercent / 100 / 12;
      if (i === 0) return principal / months;
      return principal * (i / (1 - Math.pow(1 + i, -months)));
    }
    const fmtEUR = n => n.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    const fmtPct = n => n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' %';

    const amountEl = document.getElementById('ft-amount');
    const durationRadios = document.querySelectorAll('input[name="ft-duration"]');
    const rateEl = document.getElementById('ft-rate');
    const netEl = document.getElementById('ft-net');
    const effEl = document.getElementById('ft-effRate');
    const countEl = document.getElementById('ft-count');
    const totalEl = document.getElementById('ft-total');
    const resultEl = document.getElementById('ft-result');
    const ctaApply = document.getElementById('ft-ctaApply');
    const msgUnder = document.getElementById('ft-msgUnder');
    const msgUnderText = document.getElementById('ft-msgUnderText');
    const msgOver = document.getElementById('ft-msgOver');
    const msgMinRate = document.getElementById('ft-msgMinRate');
    const productSearch = document.getElementById('ft-productSearch');
    const productGrid = document.getElementById('ft-productGrid');
    const selectedProduct = document.getElementById('ft-selectedProduct');
    const selProdName = document.getElementById('ft-selProdName');
    const selProdThumb = document.getElementById('ft-selProdThumb');
    const selProdLink = document.getElementById('ft-selProdLink');
    const selProdVariant = document.getElementById('ft-selProdVariant');
    const variantPicker = document.getElementById('ft-variantPicker');
    
    let filteredProducts = [];
    let currentPage = 0;

    let productPager = null;
    if (productGrid) {
      productPager = document.createElement('div');
      productPager.className = 'ft-pager';
      productPager.setAttribute('aria-label', 'Produkt-Seiten');
      productGrid.insertAdjacentElement('afterend', productPager);
    }
    let currentProduct = null;
    let currentVariant = null;
    const currentCountry = (root.dataset.country || 'DE').toUpperCase();
    const isDE = currentCountry === 'DE';

    // CTA disabled wenn nicht DE
    if (ctaApply && !isDE) {
      ctaApply.setAttribute('aria-disabled', 'true');
      ctaApply.title = 'Finanzierung nur für Kunden in Deutschland verfügbar';
    }

    function checkEdgeCases(amount) {
      if (amount < MIN_AMOUNT) {
        const diff = MIN_AMOUNT - amount;
        if (msgUnderText) msgUnderText.textContent = `Finanzierung ist ab ${fmtEUR(MIN_AMOUNT)} möglich – noch ${fmtEUR(diff)} entfernt.`;
        msgUnder && msgUnder.classList.add('is-active');
        msgOver && msgOver.classList.remove('is-active');
        return false;
      }
      if (amount > MAX_AMOUNT) {
        msgOver && msgOver.classList.add('is-active');
        msgUnder && msgUnder.classList.remove('is-active');
        return false;
      }
      msgUnder && msgUnder.classList.remove('is-active');
      msgOver && msgOver.classList.remove('is-active');
      return true;
    }

    function getSelectedDuration() {
      const c = document.querySelector('input[name="ft-duration"]:checked');
      return c ? parseInt(c.value, 10) : 24;
    }

    function update() {
      if (!amountEl) return;
      const amountRaw = parseFloat(amountEl.value) || 0;
      const valid = checkEdgeCases(amountRaw);
      const amount = Math.max(MIN_AMOUNT, Math.min(MAX_AMOUNT, amountRaw));
      const months = getSelectedDuration();
      const effRate = RATE_BY_DURATION[months] != null ? RATE_BY_DURATION[months] : 0;
      const rate = calcRate(amount, months, effRate);
      const total = rate * months;
      if (rateEl) rateEl.textContent = fmtEUR(rate);
      if (netEl) netEl.textContent = fmtEUR(amount);
      if (effEl) effEl.textContent = fmtPct(effRate);
      if (countEl) countEl.textContent = months;
      if (totalEl) totalEl.textContent = fmtEUR(total);
      const belowMinRate = rate < MIN_RATE && valid;
      if (rateEl) rateEl.style.color = belowMinRate ? '#7a5a00' : '';
      if (msgMinRate) msgMinRate.classList.toggle('is-active', belowMinRate);
      if (resultEl) resultEl.classList.toggle('is-disabled', !valid);
      if (ctaApply) {
        const disabled = !valid || !isDE;
        ctaApply.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }
    }

    function renderProducts(query) {
      const q = (query || '').trim().toLowerCase();
      const financeable = products.filter(p => p.price >= MIN_AMOUNT);
      filteredProducts = financeable.filter(p =>
        !q || (p.name && p.name.toLowerCase().includes(q)) || (p.category && p.category.toLowerCase().includes(q))
      );
      currentPage = 0;
      renderGrid();
    }

    function renderGrid() {
      if (!productGrid) return;
      const totalPages = Math.ceil(filteredProducts.length / PRODUCTS_PER_PAGE);
      if (currentPage > totalPages - 1) currentPage = Math.max(0, totalPages - 1);

      if (!filteredProducts.length) {
        productGrid.innerHTML = '<div class="ft-empty">Keine Produkte gefunden.</div>';
        renderPager(0);
        return;
      }

      const start = currentPage * PRODUCTS_PER_PAGE;
      const pageItems = filteredProducts.slice(start, start + PRODUCTS_PER_PAGE);
      productGrid.innerHTML = pageItems.map(p => {
        const overMax = p.price > MAX_AMOUNT;
        const selected = currentProduct && currentProduct.id === p.id;
        const thumb = p.image
          ? `<img src="${p.image}" alt="" loading="lazy">`
          : '';
        const link = p.url
          ? `<a class="ft-prod-card__link" href="${escapeHTML(p.url)}">Zum Produkt →</a>`
          : '';
        // „Ab"-Präfix nur wenn Varianten mit unterschiedlichen Preisen existieren
        let pricePrefix = '';
        if (Array.isArray(p.variants) && p.variants.length > 1) {
          const prices = p.variants.map(v => v.price);
          if (Math.min(...prices) !== Math.max(...prices)) pricePrefix = '<span class="ft-prod-card__price-prefix">Ab </span>';
        }
        return `
          <div class="ft-prod-card${selected ? ' is-selected' : ''}"
               data-id="${p.id}" role="option" tabindex="0"
               aria-selected="${selected ? 'true' : 'false'}">
            <div class="ft-prod-card__thumb">${thumb}</div>
            <div class="ft-prod-card__name">${escapeHTML(p.name || '')}</div>
            <div class="ft-prod-card__price">${pricePrefix}${fmtEUR(p.price)}</div>
            ${overMax ? '<div class="ft-prod-card__warning">über 12.000 €</div>' : ''}
            ${link}
          </div>`;
      }).join('');
      productGrid.querySelectorAll('.ft-prod-card').forEach(el => {
        el.addEventListener('click', (e) => {
          if (e.target.closest('.ft-prod-card__link')) return;
          selectProduct(el.dataset.id);
        });
        el.addEventListener('keydown', (e) => {
          if (e.target.closest('.ft-prod-card__link')) return;
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectProduct(el.dataset.id);
          }
        });
      });
      renderPager(totalPages);
    }

    function renderPager(totalPages) {
      if (!productPager) return;
      if (totalPages <= 1) { productPager.innerHTML = ''; return; }
      let html = `<button type="button" class="ft-pager__btn ft-pager__nav" data-page="${currentPage - 1}"${currentPage === 0 ? ' disabled' : ''} aria-label="Vorherige Seite">‹</button>`;
      for (let i = 0; i < totalPages; i++) {
        html += `<button type="button" class="ft-pager__btn${i === currentPage ? ' is-current' : ''}" data-page="${i}"${i === currentPage ? ' aria-current="page"' : ''}>${i + 1}</button>`;
      }
      html += `<button type="button" class="ft-pager__btn ft-pager__nav" data-page="${currentPage + 1}"${currentPage === totalPages - 1 ? ' disabled' : ''} aria-label="Nächste Seite">›</button>`;
      productPager.innerHTML = html;
      productPager.querySelectorAll('.ft-pager__btn').forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.disabled) return;
          const target = parseInt(btn.dataset.page, 10);
          if (isNaN(target) || target === currentPage) return;
          currentPage = target;
          renderGrid();
          const cur = productPager.querySelector('.ft-pager__btn.is-current');
          if (cur) cur.focus({ preventScroll: true });
        });
      });
    }

    function escapeHTML(s) {
      return String(s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function applyVariant(variant) {
      currentVariant = variant || null;
      if (!variant) return;
      if (amountEl) amountEl.value = Number(variant.price).toFixed(2);
      if (selProdLink && currentProduct && currentProduct.url) {
        try {
          const url = new URL(currentProduct.url, window.location.origin);
          url.searchParams.set('variant', variant.id);
          selProdLink.href = url.pathname + url.search + url.hash;
        } catch (e) {
          selProdLink.href = currentProduct.url;
        }
        selProdLink.style.display = '';
      }
      update();
    }

    function selectProduct(id, variantId) {
      const p = products.find(x => String(x.id) === String(id));
      if (!p) return;
      currentProduct = p;
      if (selectedProduct) selectedProduct.style.display = 'flex';
      if (selProdName) selProdName.textContent = p.name;
      if (selProdThumb) selProdThumb.innerHTML = p.image ? `<img src="${p.image}" alt="">` : '';

      const variants = Array.isArray(p.variants) ? p.variants : [];

      // Dropdown + Picker-Container nur zeigen wenn mehr als eine Variante existiert
      if (selProdVariant) {
        if (variants.length > 1) {
          selProdVariant.innerHTML = variants.map(v => {
            const label = `${v.title} – ${fmtEUR(v.price)}${v.available === false ? ' (nicht verfügbar)' : ''}`;
            return `<option value="${escapeHTML(String(v.id))}"${v.available === false ? ' disabled' : ''}>${escapeHTML(label)}</option>`;
          }).join('');
          if (variantPicker) variantPicker.style.display = '';
        } else {
          selProdVariant.innerHTML = '';
          if (variantPicker) variantPicker.style.display = 'none';
        }
      }

      // Variante wählen: explizite ID, sonst erste verfügbare, sonst erste überhaupt
      let chosen = null;
      if (variantId) chosen = variants.find(v => String(v.id) === String(variantId)) || null;
      if (!chosen) chosen = variants.find(v => v.available !== false) || variants[0] || null;
      if (chosen && selProdVariant && variants.length > 1) selProdVariant.value = chosen.id;

      if (chosen) {
        applyVariant(chosen);
      } else {
        // Fallback: Produkt hat keine Varianten im JSON — Produktpreis nutzen
        if (amountEl) amountEl.value = Number(p.price).toFixed(2);
        if (selProdLink) {
          if (p.url) { selProdLink.href = p.url; selProdLink.style.display = ''; }
          else { selProdLink.style.display = 'none'; }
        }
        update();
      }
      renderGrid();
    }

    function clearSelection() {
      if (currentProduct) {
        currentProduct = null;
        currentVariant = null;
        if (selectedProduct) selectedProduct.style.display = 'none';
        if (selProdVariant) selProdVariant.innerHTML = '';
        if (variantPicker) variantPicker.style.display = 'none';
        document.querySelectorAll('.ft-prod-card').forEach(el => {
          el.classList.remove('is-selected');
          el.setAttribute('aria-selected', 'false');
        });
      }
    }

    if (amountEl) amountEl.addEventListener('input', () => { clearSelection(); update(); });
    durationRadios.forEach(r => r.addEventListener('change', update));
    if (productSearch) productSearch.addEventListener('input', e => renderProducts(e.target.value));
    if (selProdVariant) selProdVariant.addEventListener('change', () => {
      if (!currentProduct || !Array.isArray(currentProduct.variants)) return;
      const v = currentProduct.variants.find(x => String(x.id) === String(selProdVariant.value));
      if (v) applyVariant(v);
    });

    // Anchor-Nav: aktiven Link beim Scrollen markieren
    const navLinks = document.querySelectorAll('.ft-anchor-nav a');
    const sectionIds = ['hero','rechner','ablauf','voraussetzungen','trust','faq','datenschutz'];
    const sections = sectionIds.map(id => document.getElementById(id)).filter(Boolean);
    function updateActiveAnchor() {
      const scrollY = window.scrollY + 100;
      let activeId = sections[0] ? sections[0].id : null;
      for (const sec of sections) {
        if (sec.offsetTop <= scrollY) activeId = sec.id;
      }
      navLinks.forEach(a => {
        a.classList.toggle('is-active', a.getAttribute('href') === `#${activeId}`);
      });
    }
    window.addEventListener('scroll', updateActiveAnchor, { passive: true });

        // === Sticky Theme-Header vermessen → Anchor-Nav dockt darunter an ===
    const themeHeader =
      document.querySelector('.shopify-section-group-header-group .header-wrapper') ||
      document.querySelector('sticky-header') ||
      document.querySelector('.shopify-section-group-header-group') ||
      document.querySelector('header[role="banner"]') ||
      document.querySelector('header');

    let lastHeaderH = -1;
    function syncHeaderOffset() {
      let h = 0;
      if (themeHeader) {
        // Unterkante des Headers im Viewport; <= 0 sobald er weggescrollt ist
        h = Math.max(0, Math.round(themeHeader.getBoundingClientRect().bottom));
      }
      if (h !== lastHeaderH) {
        lastHeaderH = h;
        document.documentElement.style.setProperty('--ft-header-h', h + 'px');
      }
    }
    window.addEventListener('scroll', syncHeaderOffset, { passive: true });
    window.addEventListener('resize', syncHeaderOffset, { passive: true });
    window.addEventListener('load', syncHeaderOffset);
    syncHeaderOffset();

    // Init
    renderProducts('');
    update();
    updateActiveAnchor();

    // Vorbefüllung aus URL-Parametern (Badge-Link von der Produktseite)
    (function initFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const betragCent = parseInt(params.get('betrag'), 10) || null;
      const laufzeit   = params.get('laufzeit');
      const pid        = params.get('pid');
      const variantId  = params.get('variant');
      if (!betragCent && !pid && !laufzeit) return;

      // Laufzeit zuerst setzen, damit selectProduct/update mit der richtigen Laufzeit rechnet
      if (laufzeit) {
        const radio = document.getElementById('ft-dur' + laufzeit);
        if (radio) radio.checked = true;
      }

      // Produkt + Variante im Grid vorwählen: passende Seite öffnen, Karte markieren, Result-Box füllen
      if (pid) {
        const product = products.find(x => String(x.id) === String(pid));
        if (product) {
          const idx = filteredProducts.findIndex(x => String(x.id) === String(product.id));
          if (idx >= 0) currentPage = Math.floor(idx / PRODUCTS_PER_PAGE);
          selectProduct(product.id, variantId);
        }
      }

      // betrag aus URL ist die Wahrheit zum Klick-Zeitpunkt (vom PDP-Badge gestempelt) und
      // überschreibt den JSON-Preis. Schützt vor stale Variantendaten im Page-Cache UND
      // vor dem Fall, dass die Variante nicht in der Rechner-Kollektion ist.
      if (betragCent && amountEl) {
        amountEl.value = (betragCent / 100).toFixed(2);
        update();
      }
    })();
  })();

  } catch(e) { console.error(e); }
})();
})();
